//copyright itestra 2016
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { KeycloakService, KeycloakAuth } from "./app/security";
import { environment } from "./environments/environment";
import { zbdGlobals } from "./globals";
import { tokenParsed } from "./app/security/keycloak.service";
//import * as config from "config/envconstants"

console.log(
    `ZBD version ${version.BUILD_VERSION}, backend service is at: ${config.ZBDSERVICEURL}`,
);

if (environment.production) {
    enableProdMode();
}

declare function _zbd_setupSeamless(): void;

class Bootstrap {
    static launch() {
        platformBrowserDynamic().bootstrapModule(AppModule);
    }

    static launchWithKeycloak(kcAuth?: KeycloakAuth) {
        if (window.location.pathname === "/zbd/version") {
            Bootstrap.launch();
        } else {
            Bootstrap.withKeycloak(kcAuth).then(Bootstrap.launch);
        }
    }

    static launchEmbedded() {
        console.log("Embedded mode, waiting for Keycloak tokens.");
        window.addEventListener("message", Bootstrap.handleMessage);
        _zbd_setupSeamless();
    }

    static withKeycloak(kcAuth?: KeycloakAuth): Promise<tokenParsed> {
        return KeycloakService.init(config.KEYCLOAKCONFIGURL, kcAuth).catch(
            (error) => {
                console.error("Keycloak initialization failed");
                throw error;
            },
        );
    }

    static handleMessage(event) {
        let msg: any;
        try {
            msg = JSON.parse(event.data);
        } catch (e) {
            console.log(
                "Received message is not valid JSON (%s): %s",
                encodeURIComponent(e),
                encodeURIComponent(event.data),
            );
            return;
        }
        if (msg.type !== "keycloak-init") {
            console.log(
                "Received message of unknown type, expected: 'keycloak-init', received: %s",
                encodeURIComponent(msg.type),
            );
            return;
        }
        if (!msg.token || !msg.idToken) {
            console.error("'keycloak-init' message is malformed.");
            return;
        }
        window.removeEventListener("message", Bootstrap.handleMessage);

        // Passing the refreshToken will force a refresh immediately, which fails.
        const kcAuth = {
            token: msg.token,
            idToken: msg.idToken,
        } as KeycloakAuth;
        console.log("Received Keycloak tokens, launching.");
        Bootstrap.launchWithKeycloak(kcAuth);
    }

    static getQueryString(field: string): string {
        const href = window.location.href;
        const reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
        const result = reg.exec(href);
        return result ? result[1] : undefined;
    }
}

let mode = Bootstrap.getQueryString("mode");
if (!mode) {
    mode = "standalone";
}
if (Bootstrap.getQueryString("embedded")) {
    // ZAS compatibility
    mode = "embedded";
}
switch (mode) {
    case "embedded":
        zbdGlobals.embedded = true;
        Bootstrap.launchEmbedded();
        break;
    case "local":
        console.log("Starting without keycloak.");
        Bootstrap.launch();
        break;
    case "standalone":
        Bootstrap.launchWithKeycloak();
        break;
    default:
        console.error("Unknown startup mode: %s", encodeURIComponent(mode));
        break;
}
